<section class="bg-light-grey h-full">
  <div class="flex items-center justify-center min-h-screen">
    <div class="py-8 px-4 mx-auto max-w-screen-xl h-full lg:py-16 grid lg:grid-cols-12 gap-8 lg:gap-16 items-center">

      <!-- Form Section -->
      <div class="col-span-6">
        <div class="w-full lg:max-w-xl p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow-xl dark:bg-gray-800">
          <a href="#" class="inline-flex items-center mb-4 text-xl font-semibold text-gray-900 dark:text-white">
            <img src="assets/images/logo.svg" alt="logo" class="w-[200px]" />
          </a>
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
            Create new password
          </h2>

          <form class="mt-8 space-y-6" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
           <!-- New Password Field -->
            <div>
              <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">New
                Password</label>
              <div class="relative">
                <!-- Password Field -->
                <input [type]="isPasswordVisible ? 'text' : 'password'" id="password" formControlName="password"
                  placeholder="Enter your password" autocomplete="new-password"
                  class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 text-sm focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />
                <button type="button" class="absolute top-0 right-0 p-3.5 rounded-e-md"
                  (click)="togglePasswordVisibility()">
                  <svg class="flex-shrink-0 size-4 text-blue-800 dark:text-white" width="24" height="24"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <!-- Eye icon when password is hidden -->
                    <path *ngIf="!isPasswordVisible" stroke="currentColor" d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                    <path *ngIf="!isPasswordVisible" stroke="currentColor"
                      d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path *ngIf="!isPasswordVisible" stroke="currentColor"
                      d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line *ngIf="!isPasswordVisible" x1="2" x2="22" y1="2" y2="22"></line>

                    <!-- Eye icon when password is visible -->
                    <path *ngIf="isPasswordVisible" stroke="currentColor"
                      d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle *ngIf="isPasswordVisible" cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
                <div *ngIf="resetPasswordForm.get('password')?.invalid && (resetPasswordForm.get('password')?.dirty || resetPasswordForm.get('password')?.touched)"
                  class="text-red-500 text-sm mt-2">
                  <div *ngIf="resetPasswordForm.get('password')?.errors?.['required']">Password is required</div>
                  <div *ngIf="resetPasswordForm.get('password')?.errors?.['minlength']">Password must be at least 8
                    characters long</div>
              </div>
              </div>
            </div>

            <!-- Confirm Password Field -->
            <div>
              <label for="cpassword" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Confirm
                Password</label>
              <div class="relative">
                <!-- Confirm Password Field -->
                <input [type]="isConfirmPasswordVisible ? 'text' : 'password'" id="cpassword"
                  formControlName="cpassword" placeholder="Confirm your password" autocomplete="new-password"
                  class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 text-sm focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />
                <button type="button" class="absolute top-0 right-0 p-3.5 rounded-e-md"
                  (click)="toggleConfirmPasswordVisibility()">
                  <svg class="flex-shrink-0 size-4 text-blue-800 dark:text-white" width="24" height="24"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <!-- Eye icon when confirm password is hidden -->
                    <path *ngIf="!isConfirmPasswordVisible" stroke="currentColor" d="M9.88 9.88a3 3 0 1 0 4.24 4.24">
                    </path>
                    <path *ngIf="!isConfirmPasswordVisible" stroke="currentColor"
                      d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path *ngIf="!isConfirmPasswordVisible" stroke="currentColor"
                      d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line *ngIf="!isConfirmPasswordVisible" x1="2" x2="22" y1="2" y2="22"></line>

                    <!-- Eye icon when confirm password is visible -->
                    <path *ngIf="isConfirmPasswordVisible" stroke="currentColor"
                      d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle *ngIf="isConfirmPasswordVisible" cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
                <div  *ngIf="resetPasswordForm.get('cpassword')?.invalid && (resetPasswordForm.get('cpassword')?.dirty || resetPasswordForm.get('cpassword')?.touched)"
                  class="text-red-500 text-sm mt-2">
                  <div *ngIf="resetPasswordForm.get('cpassword')?.errors?.['required']">Confirm password is required
                  </div>
                  <div class="mt-2" *ngIf="resetPasswordForm.get('cpassword')?.errors?.['minlength']">Confirm password must be at
                    least 8 characters long</div>
                  <div class="mt-2" *ngIf="resetPasswordForm.get('cpassword')?.errors?.['mustMatch']">Passwords do not
                    match</div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="flex flex-col md:flex-row items-center gap-3 pt-4">
              <button type="submit"
                class="flex items-center justify-center w-full px-5 py-3 text-sm md:text-base font-medium text-center text-white rounded-lg  sm:w-auto"
                [disabled]="resetPasswordForm.invalid" [ngClass]="{
                  'bg-gray-400 cursor-not-allowed': resetPasswordForm.invalid, 
                  'bg-primary-500 hover:bg-primary-600': !resetPasswordForm.invalid
                }"><svg *ngIf="isLoading" aria-hidden="true" role="status" class="inline w-4 h-4 me-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                  </svg>
                Reset Password
              </button>
              <a
                class="cursor-pointer md:ms-auto text-sm font-medium text-primary-600 hover:underline dark:text-primary-500" routerLink="/auth/login">Return
                to Login</a>
            </div>
          </form>
        </div>
      </div>

      <!-- SVG Section -->
      <div class="col-span-6">
        <img src="assets/images/confirm-password.svg" alt="illustration" class="hidden mx-auto lg:block">
      </div>
    </div>
  </div>
</section>
